import { z } from "zod";
import { NOTES_TABLES } from "../../../types/notes";

export const getForeignNotesSchema = z.object({
	notesTable: z.enum(NOTES_TABLES),
	identifier: z.string().uuid(),
});
